import React, { useMemo } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import Select from "components/ui/Select";
import useModalStore from "store/modals";
import { useAllSizeGroupings } from "http-hooks/sizeGrouping/useSizeGrouping";

const SelectSizeGrouping = ({
  value,
  onChange,
  placeholder = "Select size group...",
  isDisabled = false,
  isRequired = false,
  label = "Size Group",
  className = "",
  showLabel = true,
  isClearable = true,
  showAddButton = true,
}) => {
  const { openModal } = useModalStore();

  const { isLoading, data: { data: allGroups } = {} } = useAllSizeGroupings({
    noPagination: true,
  });

  const groupOptions = useMemo(
    () =>
      allGroups?.map((g) => ({
        value: g.id,
        label: g.size_uom ? `${g.name} (${g.size_uom})` : g.name,
        id: g.id,
        name: g.name,
        size_uom: g.size_uom,
      })) || [],
    [allGroups]
  );

  const handleAddNew = () => {
    openModal("sizeGrouping");
  };

  return (
    <div>
      {showLabel && (
        <div className="flex items-center justify-between mb-2">
          <label className="block text-sm font-medium leading-6 text-gray-900">
            {label}
          </label>
          {showAddButton && !isDisabled && (
            <button
              type="button"
              onClick={handleAddNew}
              className="ml-2 p-1 text-xs font-bold bg-black text-white rounded hover:bg-gray-800 transition-colors duration-200 flex items-center"
              title="Add new size group"
            >
              <PlusIcon className="h-3 w-3" aria-hidden="true" />
            </button>
          )}
        </div>
      )}
      <Select
        value={value}
        onChange={onChange}
        options={groupOptions}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isRequired={isRequired}
        label={label}
        className={className}
        showLabel={false}
        isClearable={isClearable}
        isSearchable={true}
      />
    </div>
  );
};

export default SelectSizeGrouping;
